/**
 * Implements tokens section placeholder
 */
import Skeleton from 'react-loading-skeleton';

const TokensPlaceholder = () => {
  return (
    <div className='tokens'>
      <div className='tokens__list'>
        <Skeleton width={55} height={24} />
        <div className='tokens__list__items'>
          <Skeleton height={30} count={5} />
        </div>
      </div>
      <div className='tokens__distribution'>
        <div className='tokens__distribution__header'>
          <div className='tokens__distribution__header__subtitle'>
            <Skeleton width={65} height={16} />
          </div>
          <Skeleton width={384} height={16} />
        </div>
        <div className='tokens__distribution__body'>
          <div className='tokens__distribution__body__comparison'>
            <Skeleton width={384} height={48} />
          </div>
          <div className='tokens__distribution__body__schema'>
            <Skeleton width={384} height={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokensPlaceholder;
